<template>
    <div>
        <ViewBook />
    </div>
</template>

<script>
import ViewBook from "@/components/ViewBook.vue";

export default {
    data() {
        return {
            hasLoaded: false,
        };
    },
    name: "ViewEbook",
    components: {
        ViewBook,
    },
    methods: {},
    mounted() {
        this.hasLoaded = true;
    },
};
</script>
<style scoped src="../assets/scss/main.css"></style>
